module.exports = __webpack_public_path__ + "static/media/svg-2.b333f047.svg";